import React from 'react';

import {
  Fab,
  Chip,
  Paper,
  Select,
  Button,
  MenuItem,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import TrplSelect from '../../../common/TrplControls/TrplSelect';
import TrplCheckbox from '../../../common/TrplControls/TrplCheckbox';

export default ({
  flow,
  stimul,
  classes,
  style,
  stimuls,
  btnsTypes,
  stimulIndex,
  stimulsTypes,
  onStimulBtnAdd,
  onStimulBtnRemove,
  onStimulTypeChange,
  onStimulFieldChange,
  onDeleteStimulClick,
  onStimulCodeFieldClick,
  onStimulBtnInputChange,
  onStimulModalPidsChange,
  onEditStimulBtnInputChange,
}) => {
  const selectClassNames = {
    select: classes.trplSelect,
    icon: classes.trplSelectIcon,
    root: classes.trplSelectContainer,
  };

  const menuProps = {
    classes: {
      paper: classes.trplSelectMenu,
    },
  };

  const itemStyles = {
    minHeight: '24px',
    lineHeight: 'normal',
    fontSize: '12px',
    padding: '0 16px',
  };

  const stimulsValues = ['none'];

  stimuls.forEach((stml) => {
    if (stimul.id === stml.id) return;

    stimulsValues.push(stml.id);
  });

  return (
    <Paper
      className={`${classes.p10} ${classes.mb10} ${classes.alignCenter}`}
      style={{
        justifyContent: 'space-between',
        ...style,
      }}
    >
      <div>
        <div className={classes.mb10}>
          {stimul.id ? (
            <div className={classes.mb10} style={{ fontWeight: '900' }}>
              {stimul.id}
            </div>
          ) : null}

          <TextField
            fullWidth
            multiline
            rows="4"
            label="Text"
            disableunderline
            value={stimul.text}
            onChange={(e) => onStimulFieldChange(stimulIndex, 'text', e.target.value)}
            className={classes.stimulText}
          />
        </div>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Advanced</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            <TrplSelect
              title="Type"
              margin="none"
              value={stimul.type || 'none'}
              values={['none', ...stimulsTypes]}
              onChange={(e) => onStimulTypeChange(stimulIndex, e.target.value)}
            />

            <FormControl
              style={{
                width: '100%',
              }}
            >
              <InputLabel>Pids</InputLabel>

              <Select
                multiple
                MenuProps={menuProps}
                disableunderline
                className={classes.mb20}
                classes={selectClassNames}
                onChange={(e) => onStimulModalPidsChange(stimulIndex, e.target.value)}
                value={stimul.pids}
                style={{ width: '100%', border: '1px solid #ccc' }}
                renderValue={(selected) => (
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    {flow.category && stimul.pids
                      ? selected.map((pid, index) => {
                          const selectedPid = flow.pidsValue.find((sPid) => sPid.id === pid);

                          return (
                            <Chip
                              key={index}
                              label={selectedPid ? selectedPid.title : 'Not found'}
                              style={{
                                margin: '2px',
                                fontSize: '11px',
                              }}
                              className={classes.chip}
                              size="small"
                            />
                          );
                        })
                      : null}
                  </div>
                )}
              >
                {flow.pidsValue.map((pid, index) => {
                  return (
                    <MenuItem style={itemStyles} key={index} value={pid.id}>
                      {pid.id} : {pid.title}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <div className={`${classes.fw} ${classes.mr10} ${classes.mb10}`}>
              <TrplSelect
                margin="none"
                title="Evoked stimul"
                values={stimulsValues}
                value={stimul.evoked_stimul || 'none'}
                onChange={(e) => onStimulFieldChange(stimulIndex, 'evoked_stimul', e.target.value)}
              />
            </div>

            <div className={`${classes.mb10}`}>
              <TextField
                fullWidth
                multiline
                rows={2}
                maxRows={10}
                variant="outlined"
                label="On sending:"
                disableunderline
                value={stimul.func_send}
                onClick={() => onStimulCodeFieldClick(stimulIndex, 'func_send')}
                onChange={(e) => onStimulFieldChange(stimulIndex, 'func_send', e.target.value)}
              />
            </div>

            <div className={classes.mb10}>
              <TextField
                fullWidth
                multiline
                rows={2}
                maxRows={10}
                variant="outlined"
                disableunderline
                label="On receiving:"
                value={stimul.func_receive}
                onClick={() => onStimulCodeFieldClick(stimulIndex, 'func_receive')}
                onChange={(e) => onStimulFieldChange(stimulIndex, 'func_receive', e.target.value)}
              />
            </div>

            <div className={classes.mb10}>
              <TextField
                fullWidth
                multiline
                rows={2}
                maxRows={10}
                disableunderline
                variant="outlined"
                label="On text processing:"
                value={stimul.func_on_text}
                onClick={() => onStimulCodeFieldClick(stimulIndex, 'func_on_text')}
                onChange={(e) => onStimulFieldChange(stimulIndex, 'func_on_text', e.target.value)}
              />
            </div>

            <div>
              <p>Buttons:</p>

              {stimul.buttons ? (
                <div>
                  {stimul.buttons.map((btn, btnIndex) => {
                    return (
                      <div key={btnIndex} className={`${classes.mb10} ${classes.alignCenter}`}>
                        <TextField
                          value={btn.title}
                          disableunderline
                          onChange={(e) => onEditStimulBtnInputChange(stimulIndex, btnIndex, 'title', e.target.value)}
                          className={`${classes.fw} ${classes.mr10}`}
                          label="Title"
                        />

                        <div className={`${classes.fw} ${classes.mr10}`}>
                          <TrplSelect
                            title="Type"
                            margin="none"
                            disableunderline
                            values={btnsTypes}
                            value={btn.type || 'TEXT'}
                            onChange={(e) => onEditStimulBtnInputChange(stimulIndex, btnIndex, 'type', e.target.value)}
                          />
                        </div>

                        <TextField
                          disableunderline
                          value={btn.fallback}
                          onChange={(e) =>
                            onEditStimulBtnInputChange(stimulIndex, btnIndex, 'fallback', e.target.value)
                          }
                          onClick={() => onStimulCodeFieldClick(stimulIndex, 'fallback', btnIndex)}
                          className={`${classes.fw} ${classes.mr10}`}
                          label="Function"
                        />

                        <div className={`${classes.fw} ${classes.mr10}`}>
                          <TrplSelect
                            margin="none"
                            title="Evoked stimul"
                            values={stimulsValues}
                            value={btn.evoked_stimul || 'none'}
                            onChange={(e) =>
                              onEditStimulBtnInputChange(stimulIndex, btnIndex, 'evoked_stimul', e.target.value)
                            }
                          />
                        </div>

                        <Fab
                          size="small"
                          color="secondary"
                          style={{ zoom: '0.8', flexShrink: '0' }}
                          onClick={() => onStimulBtnRemove(stimulIndex, btnIndex)}
                        >
                          <DeleteIcon />
                        </Fab>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              <div className={`${classes.alignCenter} ${classes.mb10}`}>
                <TextField
                  disableunderline
                  onChange={(e) => onStimulBtnInputChange(stimulIndex, 'btn_title', e.target.value)}
                  className={`${classes.fw} ${classes.mr10}`}
                  value={stimul.btn_title}
                  label="Title"
                />

                <div className={`${classes.fw} ${classes.mr10}`}>
                  <TrplSelect
                    margin="none"
                    title="Type"
                    disableunderline
                    values={btnsTypes}
                    value={stimul.btn_type || 'TEXT'}
                    onChange={(e) => onStimulBtnInputChange(stimulIndex, 'btn_type', e.target.value)}
                  />
                </div>

                <TextField
                  disableunderline
                  onChange={(e) => onStimulBtnInputChange(stimulIndex, 'btn_fallback', e.target.value)}
                  className={`${classes.fw} ${classes.mr10}`}
                  value={stimul.btn_fallback}
                  label="Function"
                />

                <div className={`${classes.fw} ${classes.mr10}`}>
                  <TrplSelect
                    margin="none"
                    title="Evoked stimul"
                    values={stimulsValues}
                    value={stimul.btn_evoked_stimul || 'none'}
                    onChange={(e) => onStimulBtnInputChange(stimulIndex, 'btn_evoked_stimul', e.target.value)}
                  />
                </div>

                <Fab
                  size="small"
                  color="primary"
                  style={{ zoom: '0.8', flexShrink: '0' }}
                  onClick={() => onStimulBtnAdd(stimulIndex)}
                >
                  <AddIcon />
                </Fab>
              </div>

              <div
                style={{
                  marginBottom: '-15px',
                }}
              >
                <TrplCheckbox
                  label="Active keyboard"
                  value={stimul.active_keyboard}
                  checked={stimul.active_keyboard}
                  onChange={(e) => onStimulFieldChange(stimulIndex, 'active_keyboard', e.target.checked)}
                />
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>

      <Button size="small" variant="contained" color="secondary" onClick={onDeleteStimulClick}>
        Delete
      </Button>
    </Paper>
  );
};
